<template>
<div id="filter-modal" class="modal fade confirm" :class="{'is-open': open}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <a @click="$emit('close')" class="close">
          <i class="icon-close"></i>
        </a>
        <h3 class="modal-title">自訂篩選條件<span class="pl-5 text-red">※可勾選設定30個條件</span></h3>
      </div>
      <div class="modal-body">
        <form class="form">
          <h3 class="mt-0">個人資訊</h3>
          <div class="panel panel-default mb-2"
          :class="form.age.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-age-0" value="age" 
                @click.prevent="clickToggleAll('age')"
                v-model="formTitle">
                <label for="about-age-0">
                  <h4 class="text-green">年紀相關</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-age-1" value="idage" v-model="form.age" @click="modalFocus()">
                <label for="about-age-1">
                  年齡
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-age-2" value="birthmonth" v-model="form.age" @click="modalFocus()">
                <label for="about-age-2">
                  生日月份
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-age-3" value="agemonth" v-model="form.age" @click="modalFocus()">
                <label for="about-age-3">
                  增齡月份
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-age-4" value="recent_birthday" v-model="form.age" @click="modalFocus()">
                <label for="about-age-4">
                  近期生日
                </label>
              </div>
            </div>
          </div>
          <div class="panel panel-default mb-2"
          :class="form.info.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-info-0" value="info"  
                @click.prevent="clickToggleAll('info')"
                v-model="formTitle">
                <label for="about-info-0">
                  <h4 class="text-green">基本資料</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-info-1" value="sex" v-model="form.info" @click="modalFocus()">
                <label for="about-info-1">
                  性別
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-info-2" value="home_addr" v-model="form.info" @click="modalFocus()">
                <label for="about-info-2">
                  現居地址
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-info-3" value="groups" v-model="form.info" @click="modalFocus()">
                <label for="about-info-3">
                  所屬群組
                </label>
              </div><br/>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-info-5" value="marry" v-model="form.info" @click="modalFocus()">
                <label for="about-info-5">
                  婚姻狀況
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-info-6" value="edu" v-model="form.info" @click="modalFocus()">
                <label for="about-info-6">
                  教育程度
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-info-7" value="std_occupation_cd" v-model="form.info" @click="modalFocus()">
                <label for="about-info-7">
                  職業
                </label>
              </div>
            </div>
          </div>
          <div class="panel panel-default mb-2"
          :class="form.financial.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-financial-0" value="financial" 
                @click.prevent="clickToggleAll('financial')"
                v-model="formTitle">
                <label for="about-financial-0">
                  <h4 class="text-green">財務狀況</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-financial-1" value="incomy" v-model="form.financial" @click="modalFocus()">
                <label for="about-financial-1">
                  個人年所得
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-financial-2" value="family_incom" v-model="form.financial" @click="modalFocus()">
                <label for="about-financial-2">
                  家庭年所得
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-financial-3" value="invest" v-model="form.financial" @click="modalFocus()">
                <label for="about-financial-3">
                  月平均投資
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-financial-4" value="finance" v-model="form.financial" @click="modalFocus()">
                <label for="about-financial-4">
                  理財工具
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-financial-5" value="house" v-model="form.financial" @click="modalFocus()">
                <label for="about-financial-5">
                  住宅權屬
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-financial-6" value="car" v-model="form.financial" @click="modalFocus()">
                <label for="about-financial-6">
                  交通工具
                </label>
              </div>
            </div>
          </div>
          <div class="panel panel-default mb-2"
          :class="form.service.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-service-0" value="service" 
                @click.prevent="clickToggleAll('service')"
                v-model="formTitle">
                <label for="about-service-0">
                  <h4 class="text-green">申辦項目</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-1" value="web_member" v-model="form.service" @click="modalFocus()">
                <label for="about-service-1">
                  公司網站會員
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-2" value="online" v-model="form.service" @click="modalFocus()">
                <label for="about-service-2">
                  網路服務線上變更
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-3" value="mobile" v-model="form.service" @click="modalFocus()">
                <label for="about-service-3">
                  行動服務
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-4" value="payment" v-model="form.service" @click="modalFocus()">
                <label for="about-service-4">
                  ID一指通
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-5" value="email" v-model="form.service" @click="modalFocus()">
                <label for="about-service-5">
                  電子單據
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-6" value="trans_plpy" v-model="form.service" @click="modalFocus()">
                <label for="about-service-6">
                  轉帳申請
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-7" value="ecall" v-model="form.service" @click="modalFocus()">
                <label for="about-service-7">
                  易Call保
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-service-9" value="claimoffset" v-model="form.service" @click="modalFocus()">
                <label for="about-service-9">
                  理賠抵繳
                </label>
              </div>
            </div>
          </div>

          <div class="panel panel-default mb-2"
          :class="form.customerType.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-customerType-0" value="customerType" 
                @click.prevent="clickToggleAll('customerType')"
                v-model="formTitle">
                <label for="about-customerType-0">
                  <h4 class="text-green">客戶類型</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-1" value="custrl" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-1">
                  客戶關係
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-2" value="custrl1" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-2">
                  保單關係人
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-3" value="custrl2" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-3">
                  幾年未再購
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-4" value="custrl3" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-4">
                  近期有購買
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-5" value="custrl4" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-5">
                  投保始期
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-6" value="vip_lvl" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-6">
                  VIP客戶
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-7" value="cust_tag" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-7">
                  客戶標籤
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-8" value="cont_score" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-8">
                  親疏等級
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-customerType-9" value="match_cnt" v-model="form.customerType" @click="modalFocus()">
                <label for="about-customerType-9">
                  符合名單專區次數
                </label>
              </div>
            </div>
          </div>

          <h3>商品行銷</h3>
          <div class="panel panel-default mb-2"
          :class="form.isInsure.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-isInsure-0" value="isInsure" 
                @click.prevent="clickToggleAll('isInsure')"
                v-model="formTitle">
                <label for="about-isInsure-0">
                  <h4 class="text-green">已投保商品</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-isInsure-3" value="prod_codes_curr" v-model="form.isInsure" @click="modalFocus()">
                <label for="about-isInsure-3">
                  主約幣別
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-isInsure-1" value="prod_codes_main" v-model="form.isInsure" @click="modalFocus()">
                <label for="about-isInsure-1">
                  主約險別
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-isInsure-2" value="prod_codes_atta" v-model="form.isInsure" @click="modalFocus()">
                <label for="about-isInsure-2">
                  附約險別
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-isInsure-prod-type" value="prod_type" v-model="form.isInsure" @click="modalFocus()">
                <label for="about-isInsure-prod-type">
                  商品類別
                </label>
              </div>
            </div>
          </div>
          <div class="panel panel-default mb-2"
          :class="form.notInsure.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-notInsure-0" value="notInsure" 
                @click.prevent="clickToggleAll('notInsure')"
                v-model="formTitle">
                <label for="about-notInsure-0">
                  <h4 class="text-green">未投保商品</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-notInsure-3" value="prod_codes_n_curr" v-model="form.notInsure" @click="modalFocus()">
                <label for="about-notInsure-3">
                  主約幣別
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-notInsure-1" value="prod_codes_n_main" v-model="form.notInsure" @click="modalFocus()">
                <label for="about-notInsure-1">
                  主約險別
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-notInsure-2" value="prod_codes_n_atta" v-model="form.notInsure" @click="modalFocus()">
                <label for="about-notInsure-2">
                  附約險別
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-isInsure-prod-type-n" value="prod_type_n" v-model="form.notInsure" @click="modalFocus()">
                <label for="about-isInsure-prod-type-n">
                  商品類別
                </label>
              </div>
            </div>
          </div>
          <div class="panel panel-default mb-2"
          :class="form.cathayCustInfo.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-cathayCustInfo-0" value="cathayCustInfo" 
                @click.prevent="clickToggleAll('cathayCustInfo')"
                v-model="formTitle">
                <label for="about-cathayCustInfo-0">
                  <h4 class="text-green">泰好客</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-cathayCustInfo-1" value="mkt_level" v-model="form.cathayCustInfo"  @click.prevent="clickCathayCustInfo">
                <label for="about-cathayCustInfo-1">
                  促約潛力
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-cathayCustInfo-2" value="mkt_type" v-model="form.cathayCustInfo" @click.prevent="clickCathayCustInfo">
                <label for="about-cathayCustInfo-2">
                  商品類別
                </label>
              </div>
            </div>
          </div>
          <h3>契約事件</h3>
          <div class="panel panel-default mb-2"
          :class="form.futurePayment.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-futurePayment-0" value="futurePayment" 
                @click.prevent="clickToggleAll('futurePayment')"
                v-model="formTitle">
                <label for="about-futurePayment-0">
                  <h4 class="text-green">給付</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb- main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-futurePayment-1" value="matag_month" v-model="form.futurePayment" @click="modalFocus()">
                <label for="about-futurePayment-1">
                  滿期金即將給付
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-futurePayment-2" value="annuity_month" v-model="form.futurePayment" @click="modalFocus()">
                <label for="about-futurePayment-2">
                  年金即將給付
                </label>
              </div>
            </div>
          </div>
          <!-- <div class="panel panel-default mb-2"
          :class="form.payment.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-payment-0" value="payment" 
                @click.prevent="clickToggleAll('payment')"
                v-model="formTitle">
                <label for="about-payment-0">
                  <h4 class="text-green">續保</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-payment-1" value="pla1_month" v-model="form.payment" @click="modalFocus()">
                <label for="about-payment-1">
                  意外險
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-payment-2" value="plc1_month" v-model="form.payment" @click="modalFocus()">
                <label for="about-payment-2">
                  車險
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-payment-3" value="plf1_month" v-model="form.payment" @click="modalFocus()">
                <label for="about-payment-3">
                  火險
                </label>
              </div>
            </div>
          </div> -->
          <div class="panel panel-default mb-2"
          :class="form.payment.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-payment-0" value="payment" 
                @click.prevent="clickToggleAll('payment')"
                v-model="formTitle">
                <label for="about-payment-0">
                  <h4 class="text-green">續保</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-payment-1" value="pla1_month" v-model="form.payment" @click="modalFocus()">
                <label for="about-payment-1">
                  人壽意外險
                </label>
              </div>
            </div>
          </div>

          <div class="panel panel-default mb-2"
          :class="form.paymentProperty.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-paymentProperty-0" value="paymentProperty" 
                @click.prevent="clickToggleAll('paymentProperty')"
                v-model="formTitle">
                <label for="about-paymentProperty-0">
                  <h4 class="text-green">續保-產險</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-paymentProperty-1" value="plc1_month" v-model="form.paymentProperty" @click="modalFocus()">
                <label for="about-paymentProperty-1">
                  產險車險
                </label>
              </div>
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-paymentProperty-2" value="plf1_month" v-model="form.paymentProperty" @click="modalFocus()">
                <label for="about-paymentProperty-2">
                  產險火險
                </label>
              </div>
            </div>
          </div>

          <h3>公司往來</h3>
          <div class="panel panel-default mb-2"
          :class="form.cust_src.length ? 'is-green-border' : ''">
            <div class="form-group mb-0">
              <div class="checkbox">
                <input type="checkbox" id="about-cust_src" value="cust_src" 
                @click.prevent="clickToggleAll('cust_src')"
                v-model="formTitle">
                <label for="about-cust_src">
                  <h4 class="text-green">往來狀況與類型</h4>
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-cust_src1" value="cust_src1" v-model="form.cust_src" @click="modalFocus()">
                <label for="about-cust_src1">
                  已往來
                </label>
              </div>
            </div>
            <div class="form-group mb-0 main-list">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" id="about-cust_src0" value="cust_src0" v-model="form.cust_src" @click="modalFocus()">
                <label for="about-cust_src0">
                  未往來
                </label>
              </div>
            </div>
          </div>
          
          <div class="actions text-right">
            <span v-if="countSelection > 30" class="text-red">【已達30個設定上限】</span>
            <a @click="$emit('close')" class="btn btn-default">取消</a>
            <a v-if="countSelection <= 30" @click="$emit('submit', form)" class="btn btn-primary">儲存</a>
            <a v-else disabled class="btn btn-primary">儲存</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {commonMixin} from '../../mixins/common'
export default {
  name: "CustomizeFilter",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    customizeData: [String,Array,Object],
  },
  computed: {
    countSelection () {  // 選取選項數量
      return (this.form.age.length + this.form.info.length + this.form.financial.length + this.form.service.length + this.form.customerType.length +
      this.form.isInsure.length + this.form.notInsure.length + this.form.futurePayment.length + this.form.payment.length + this.form.cathayCustInfo.length)
    },
  }, 
  watch: {
    open: 'initForm',
    form: {
      handler:function(){
        const aaaa = this.form
        debugger
        for(let item in this.form){
          if(this.form[item].length === this.customizeDataAll[item].length && this.formTitle.indexOf(item) === -1){
            this.formTitle.push(item)
          }else if(this.form[item].length !== this.customizeDataAll[item].length && this.formTitle.indexOf(item) > -1){
            this.formTitle = this.formTitle.join(',').replace(item,'').split(',')
          }
        }
      },
      deep:true,
    },
    // formTitle: function (newAry,oldAry) {   //點選標題全選全消功能
    //   if(newAry.length > oldAry.length){
    //     let index = newAry.length -1
    //     let key = newAry[index] 
    //     this.form[key] = this.customizeDataAll[key]
    //   }
    //   else{
    //     oldAry.forEach(item => {
    //       if(newAry.indexOf(item) === -1){
    //         this.form[item] = []
    //       }
    //     })
    //   }
    // }
  },
  data () {
    return {
      form: {
        age: [],
        info: [],
        financial: [],
        service: [],
        customerType:[], //客戶類型        
        isInsure: [],
        notInsure: [],
        futurePayment: [],
        payment: [],
        paymentProperty: [],
        cathayCustInfo: [],
        cust_src: [],
      },
      formTitle: [],
      customizeDataAll:{   //過濾資料用
        age: ['idage','birthmonth','agemonth', 'recent_birthday'],
        info: ['sex','home_addr','groups','marry','edu','std_occupation_cd'],
        financial: ['incomy','family_incom','invest','finance','house','car'],
        service: ['web_member','online','mobile','payment','email','trans_plpy','ecall','claimoffset'],
        customerType:['custrl','custrl1','custrl2','custrl3','custrl4', 'vip_lvl','cust_tag','cont_score','match_cnt'],
        isInsure: ['prod_codes_main','prod_codes_atta','prod_codes_curr','prod_type'],
        notInsure: ['prod_codes_n_main','prod_codes_n_atta','prod_codes_n_curr','prod_type_n'],
        futurePayment: ['matag_month','annuity_month'],
        payment: ['pla1_month'], //人壽意外險
        paymentProperty: ['plc1_month','plf1_month'], //產險車險 產險火險
        cathayCustInfo: ['mkt_level', 'mkt_type'],
        cust_src: ['cust_src1','cust_src0'],
      },
    }
  },
  methods: {
    initForm () {
      this.form = {...this.customizeData}
    },
    modalFocus() {
      const container = document.getElementById('filter-modal');
      console.log(container);
      document.getElementById('filter-modal').focus();
    },
    clickToggleAll(itemName){
      let is_iPad = navigator.userAgent.match(/iPad/i) != null // 確認裝置是否為 iPad
      this.modalFocus();

      if(is_iPad){
        let iPad_version = navigator.userAgent.match(/\d{1,2}_\d/i)[0].split('_')
        if((iPad_version[0] > 11 && iPad_version[1] > 1) || iPad_version[0] > 12){ // 對 iPad 版本進行判斷
          if(this.formTitle.indexOf(itemName) === -1){
            this.form[itemName] = [...this.customizeDataAll[itemName]]
          }else{
            this.form[itemName] = []
          }
        }else{
          if(this.formTitle.indexOf(itemName) === -1){
            this.form[itemName] = []
          }else{
            this.form[itemName] = [...this.customizeDataAll[itemName]]
          }
        }
      }else{
        if(this.formTitle.indexOf(itemName) === -1){
          this.form[itemName] = [...this.customizeDataAll[itemName]]
        }else{
          this.form[itemName] = []
        }
      }

    },
    clickCathayCustInfo() {
      return false; //泰好客小分類不允許點擊
    }
  }
}
</script>
